export const dev_siteKey = '6LfytispAAAAALO3gaY7ttlOC7y-9798OJYApbaR';
export const prod_siteKey = '6Lf24ygpAAAAABa9Kz5YBdXR_yyVKqIaKCPwgVxq';
